import moment from 'moment';
import { path } from 'ramda';
import React from 'react';

const CacheDate = ({ meta }) => meta && path(['factGeneratedAt'], meta) ?
    <div>Статистика собрана {moment(path(['factGeneratedAt'], meta)).format('DD.MM.YYYY HH:mm')}</div> : null;

export default CacheDate;
